"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _curry = _interopRequireDefault(require("lodash/fp/curry"));

var _cond = _interopRequireDefault(require("lodash/fp/cond"));

var _isNumber = _interopRequireDefault(require("lodash/fp/isNumber"));

var _isArray = _interopRequireDefault(require("lodash/fp/isArray"));

var _identity = _interopRequireDefault(require("lodash/fp/identity"));

var _stubTrue = _interopRequireDefault(require("lodash/fp/stubTrue"));

var _constant = _interopRequireDefault(require("lodash/fp/constant"));

var _priceFromMultiprice = _interopRequireDefault(require("./priceFromMultiprice"));

var _choosePrice = _interopRequireDefault(require("./choosePrice"));

/**
 * Currying function that returns amount of price with tax or price without tax depending on `pricesType`.
 * Or `options.defaultValue` if something wrong.
 *
 * @function
 *
 * @param {Object} [options]
 * @param {string} [options.amountField = 'amount'] Name of object field with amout.
 * @param {string} [options.currencyField = 'currency'] Name of object field with amout.
 * @param {TDefault} [options.defaultValue = false] Value returned if amout is not defined.
 * @param {string} currency
 * @param {'B2B' | 'B2C' | 'B2BForeign'} pricesType
 * @param {Array<Object> | number} priceNoTax
 * @param {Array<Object> | number} priceWithTax
 *
 * @return {number | TDefault} Amount or `defaultValue`.
 */
var chooseAndEnsurePrice = (0, _curry.default)(function chooseAndEnsurePrice(options, currency, pricesType, priceNoTax, priceWithTax) {
  var _ref = options || {},
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? false : _ref$defaultValue;

  return (0, _cond.default)([[_isNumber.default, _identity.default], [_isArray.default, (0, _priceFromMultiprice.default)(options, currency)], [_stubTrue.default, (0, _constant.default)(defaultValue)]])((0, _choosePrice.default)(pricesType, priceNoTax, priceWithTax));
});
var _default = chooseAndEnsurePrice;
exports.default = _default;